import React from 'react';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input } from 'components';
import { formatDiagnosisCode, ICD10_CM_CODE_PATTERN, MAX_DIAGNOSIS_CODE_LENGTH, MAX_DIAGNOSIS_DESCRIPTION_LENGTH, useSecondaryModal } from 'utils';

/**
 * Payer service → Diagnostic Codes → "Add Diagnosis Code": type a code and its description;
 * it is selected on the service and added to the code picker's options in this modal (no request).
 *
 * @param defaultCode   what the user had typed in the picker
 * @param existingCodes codes already in the picker (chips + added ones)
 * @param onAdd         `({ code, description }) => void`
 */
export const AddServiceDiagnosisCode = ({ defaultCode = '', existingCodes = [], onAdd }) => {
    const { closeSecondary } = useSecondaryModal();
    const looksLikeCode = ICD10_CM_CODE_PATTERN.test(defaultCode.toUpperCase());
    const { handleSubmit, control, setError } = useForm({
        defaultValues: { code: looksLikeCode ? defaultCode.toUpperCase() : '', description: looksLikeCode ? '' : defaultCode },
    });

    const handleSave = (data) => {
        const code = formatDiagnosisCode(data.code.trim());
        if (existingCodes.some((existing) => formatDiagnosisCode(existing) === code)) {
            setError('code', { message: `${code} is already added.` });
            return;
        }
        onAdd({ code, description: data.description.trim() });
        closeSecondary();
    };

    return (
        <div className="diagnosis-modal">
            <p className="modal-header-title">Add Diagnosis Code</p>
            <form onSubmit={handleSubmit(handleSave)}>
                <div className="modal-body-wrapper">
                    <Input
                        name="code"
                        label="Diagnosis Code*"
                        placeholder="e.g. F84.0"
                        variant="outlined"
                        control={control}
                        maxLength={MAX_DIAGNOSIS_CODE_LENGTH}
                        rules={{ validate: (value) => !!value?.trim() || 'Diagnosis code is required.' }}
                    />
                    <Input
                        name="description"
                        label="Description*"
                        placeholder="What the code means"
                        variant="outlined"
                        control={control}
                        maxLength={MAX_DIAGNOSIS_DESCRIPTION_LENGTH}
                        rules={{ validate: (value) => !!value?.trim() || 'Description is required.' }}
                    />
                </div>
                <CreateChancel
                    type="submit"
                    create={'Add'}
                    chancel={'Cancel'}
                    onClose={closeSecondary}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
